<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/userNotification/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="detail_label">
            {{ titleLabel }}
          </div>
          <div class="detail_top_title">
            {{ userNotification.title }}
          </div>
        </div>
        <div class="detail_bottom_userNotificationDetail">
          <div class="detail_bottom_userNotificationDetail_title detail_label">
            {{ messageLabel }}
          </div>
          <div class="detail_message">{{ userNotification.message }}</div>
          <div class="detail_bottom_userNotificationDetail_title detail_label">
            {{ targetLabel }}
          </div>
          <div>
            <div v-if="userNotification.allFlag == 1">
              {{ allLabel }}
            </div>
            <div
              class="post_name"
              v-if="userNotification.allFlag == 0"
              v-for="post in userNotification.postList"
              :key="post.postId"
            >
              {{ post.postName }}
            </div>
          </div>
          <div class="detail_bottom_userNotificationDetail_title detail_label">
            {{ startLabel }}
          </div>
          <div>
            {{ formatedDate(userNotification.startDateTime) }}
          </div>
          <div class="detail_bottom_userNotificationDetail_title detail_label">
            {{ endLabel }}
          </div>
          <div>
            {{ formatedDate(userNotification.endDateTime) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      titleLabel: 'タイトル',
      messageLabel: '本文',
      targetLabel: '送信対象',
      allLabel: '全体',
      startLabel: '開始日時',
      endLabel: '終了日時'
    }
  },
  computed: {
    userNotification() {
      return this.$store.state.userNotification.userNotification
    }
  },
  methods: {
    formatedDate(unixTime) {
      const targetDate = new Date(unixTime)
      return `${targetDate.getFullYear()}/${(targetDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${targetDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${targetDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${targetDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}`
    }
  }
}
</script>
<style scoped>
.detail_message {
  min-height: 30px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
.detail_bottom_userNotificationDetail {
  width: 95%;
  color: #000;
  padding-top: 25px;
}
.detail_bottom_userNotificationDetail_title {
  font-size: 14px;
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/userNotification/userNotificationDetail.vue